import { i18n } from '@lingui/core';
import { t, Trans } from '@lingui/macro';
import { I18nProvider } from '@lingui/react';
import { Modal, Space } from 'antd';
import React from 'react';
// import { shallowEqual, useSelector } from 'react-redux';
import { TableName } from '../../redux/EditableTable/TableName';
import { store } from '../../redux/store';
import OpenNewTab from '../OpenNewTab';
import { css } from 'styled-components';
import { MyInvoisTransactionHelper } from '../../helpers/MyInvoisTransactionHelper';
import { ContactEntityType } from '../../enums/ContactEntityType';

export const MyInvoisActionModalCss = css`
    .list-item-with-open-new-tab {
        position: relative;

        .open-in-new-span {
            position: absolute;
            bottom: -2.5px;
        }
    }
`;

/**
 * https://www.notion.so/bukku/MyInvois-Transaction-Updates-07-07-2024-95e13c1c871849dba81482cb65b394aa?pvs=4#c71a56cb43c84047a28f11ba76803ec8
 * @param {number} contactId - contact id, only used to find contact (will take precedence if contactGroupId is also provided)
 * @param {number} contactGroupId - contact group id
 * @returns
 */
export default function getMyInvoisActionValidateModalPromise({
    contactId,
    contactGroupId = null,
    contact2Id = null, // only used in expense claim
    paymentMode = null, // only used in expense claim
}) {
    const {
        Company,
        List,
        Editable,
    } = store.getState();

    const { isMyInvoisReady } = Company;
    const { contacts, contactGroups } = List;
    const { items: formItems } = Editable[TableName.form_item];

    const allFormItemsHaveClassification = !MyInvoisTransactionHelper
        .hasItemsWithoutClassificationCode(formItems);
    const allItemsAreExcludedClassification = MyInvoisTransactionHelper
        .allItemsAreExcludedClassification(formItems);

    // const areAllContactPassed = false;
    const contact = contactId ? contacts.find(contact => contact.id === contactId) : undefined;
    const contact2 = contact2Id ? contacts.find(contact => contact.id === contact2Id) : undefined;
    const contactGroup = contactGroupId ?
        contactGroups.find(group => group.id === contactGroupId) :
        undefined;

    const isClaim = paymentMode ? paymentMode === 'claim' : false;
    const isContactMyInvoisReady = contact ? contact?.is_myinvois_ready : true;
    const isContact2MyInvoisReady = contact2 ? contact2?.is_myinvois_ready : true;
    const isContactGroupMyInvoisReady = contactGroup ? contactGroup?.not_myinvois_ready === 0 : true;
    const isContactAndContactGroupMyInvoisReady =
        ((!isClaim && isContactMyInvoisReady) || (isClaim && isContact2MyInvoisReady))
        && isContactGroupMyInvoisReady;

    //  General Public shouldn't be able to submit as VALIDATE
    const isContactGeneralPublic = contact ?
        contact.entity_type === ContactEntityType.GENERAL_PUBLIC.key : false;
    const isContact2GeneralPublic = contact2 ?
        contact2.entity_type === ContactEntityType.GENERAL_PUBLIC.key : false;
    const isContactGroupGeneralPublic = contactGroup ? contactGroup.general_public : false;
    const isContactOrContactGroupGeneralPublic = isContactGeneralPublic || isContact2GeneralPublic ||
                                                isContactGroupGeneralPublic;

    // if (contactGroupId && !contactId)
    //     areAllContactPassed = true;

    console.log('aaa MyInvoisActionValidateModal', {
        isMyInvoisReady,
        isContact2MyInvoisReady,
        isContactGroupMyInvoisReady,
        contact,
        allFormItemsHaveClassification,
    });

    const hardBlockOnly = (!allFormItemsHaveClassification || allItemsAreExcludedClassification) &&
                            (isMyInvoisReady && isContactAndContactGroupMyInvoisReady);
    const softBlockOnly = (allFormItemsHaveClassification && !allItemsAreExcludedClassification) && (
        !isMyInvoisReady || !isContactAndContactGroupMyInvoisReady || isContactOrContactGroupGeneralPublic
    );
    const hardAndSoftBlock = (!allFormItemsHaveClassification || allItemsAreExcludedClassification) && (
        !isMyInvoisReady || !isContactAndContactGroupMyInvoisReady || isContactOrContactGroupGeneralPublic
    );

    const getHelpText = () => {
        if (hardBlockOnly || hardAndSoftBlock) {
            return (
                <Trans>
                    Please fix them before submitting, as this invoice
                    will be submitted to LHDN&apos;s MyInvois.
                </Trans>
            );
        }
        if (softBlockOnly) {
            return (
                <div>
                    <Trans>
                        Normal transactions (not validated) will be created until fixes are made.&nbsp;
                        Please fix them to submit to LHDN&apos;s MyInvois.
                    </Trans>
                    <br />
                    <br />
                    <div>
                        <Trans>
                            How would you like to proceed for now?
                        </Trans>
                    </div>
                </div>
            );
        }

        return (
            <Trans>
                Please fix them before submitting, as this invoice
                will be submitted to LHDN&apos;s MyInvois.
            </Trans>
        );
    };

    const getModalContent = () => {
        if (hardBlockOnly || hardAndSoftBlock) {
            return (
                <>
                    {!allFormItemsHaveClassification && (
                        <li><Trans>Items having missing product classification</Trans></li>
                    )}
                    {allItemsAreExcludedClassification && (
                        <li><Trans>Items with excluded product classification cannot be submitted</Trans></li>
                    )}
                </>
            );
        }

        // soft block only
        return (
            <>
                {!isMyInvoisReady && (
                    <li>
                        <span className="list-item-with-open-new-tab">
                            <Trans>Company Profile</Trans>
                                        &nbsp;
                            <OpenNewTab href="/cp/profile" />
                        </span>
                    </li>
                )}
                {paymentMode !== "claim" && contact && !isContactMyInvoisReady && (
                    <li>
                        <span className="list-item-with-open-new-tab">
                            <Trans>Selected Contact</Trans>
                                        &nbsp;
                            <OpenNewTab href={`/contacts/${contactId}`} />
                        </span>
                    </li>
                )}
                {paymentMode !== "claim" && contact && (isContactMyInvoisReady && isContactGeneralPublic) && (
                    <li>
                        <span className="list-item-with-open-new-tab">
                            <Trans>Contact entity type - General Public is not allowed</Trans>
                                        &nbsp;
                            <OpenNewTab href={`/contacts/${contactId}`} />
                        </span>
                    </li>
                )}
                {paymentMode === "claim" && contact2 && !isContact2MyInvoisReady && (
                    <li>
                        <span className="list-item-with-open-new-tab">
                            <Trans>Selected Contact</Trans>
                                        &nbsp;
                            <OpenNewTab href={`/contacts/${contact2Id}`} />
                        </span>
                    </li>
                )}
                {paymentMode === "claim" && contact2 && (isContact2MyInvoisReady && isContact2GeneralPublic) && (
                    <li>
                        <span className="list-item-with-open-new-tab">
                            <Trans>Contact entity type - General Public is not allowed</Trans>
                                        &nbsp;
                            <OpenNewTab href={`/contacts/${contact2Id}`} />
                        </span>
                    </li>
                )}
                {contactGroup && !isContactGroupMyInvoisReady && (
                    <li>
                        <span className="list-item-with-open-new-tab">
                            <Trans>Selected Contact Group</Trans>
                                        &nbsp;
                            <OpenNewTab href={`/contacts/groups/${contactGroupId}`} />
                        </span>
                    </li>
                )}
                {contactGroup && (isContactGroupMyInvoisReady && isContactGroupGeneralPublic) && (
                    <li>
                        <span className="list-item-with-open-new-tab">
                            <Trans>
                                Contact Group - Contacts with
                                General Public entity type are not allowed
                            </Trans>
                                        &nbsp;
                            <OpenNewTab href={`/contacts/groups/${contactGroupId}`} />
                        </span>
                    </li>
                )}
            </>
        );
    };

    if (
        !isMyInvoisReady || // company profile myinvois not ready
        (paymentMode !== "claim" && !isContactMyInvoisReady) ||
        (paymentMode === "claim" && !isContact2MyInvoisReady) ||
        !isContactGroupMyInvoisReady || // contact myinvois not ready
        isContactOrContactGroupGeneralPublic || // contact entity type is general public
        !allFormItemsHaveClassification ||
        allItemsAreExcludedClassification
    ) {
        return new Promise(resolve => {
            Modal.confirm({
                title: t`MyInvois Validation`,
                closable: true,
                content: (
                    <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
                        <div>
                            <Trans>
                                The following attributes do not
                                satisfy the requirements of LHDN&apos;s MyInvois:
                            </Trans>
                        </div>
                        <Space direction="vertical" size={4}>
                            <div>
                                <ul style={{
                                    listStyle: 'disc',
                                    listStylePosition: 'inside',
                                }}
                                >
                                    {getModalContent()}
                                </ul>
                            </div>
                            <div>
                                {getHelpText()}
                            </div>
                        </Space>
                    </I18nProvider>
                ),
                okText: softBlockOnly ? t`Submit As Is, Fix Later` : t`Fix Now`,
                onOk() {
                    resolve({
                        hardBlockOnly,
                        softBlockOnly,
                        hardAndSoftBlock,
                    });
                },
                cancelButtonProps: {
                    style: { display: softBlockOnly ? 'inline-block' : 'none' },
                },
                cancelText: softBlockOnly ? t`Fix Now` : null,
                onCancel: softBlockOnly ? () => {
                    // resolve({
                    //     hardBlockOnly: false,
                    //     softBlockOnly: false,
                    //     hardAndSoftBlock: false,
                    // });
                } : undefined,
                // keyboard: false,
            });
        });
    }

    return Promise.resolve({
        hardBlockOnly: false,
        softBlockOnly: false,
        hardAndSoftBlock: false,
    });
}
